import Dashboard from "../../dashboard/Dashboard";
import Button from "../../../components/buttons/Button";
import "../../../components/generalComponents.scss";
import style from "../../reviews/review.module.scss";
import { faArrowLeftLong } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";

export default function WorkExperienceDetail() {
  const router = useNavigate();
  return (
    <Dashboard>
      <>
        <div style={{ display: "flex" }}>
          <FontAwesomeIcon
            icon={faArrowLeftLong}
            onClick={() => router(-1)}
            style={{
              marginTop: "1px",
              marginRight: "0.7rem",
              cursor: "pointer",
            }}
          />
          <h5 style={{ marginRight: "4rem" }}>Work Experience Details</h5>
        </div>

        <div className="section">
          <div className={style.textWrapper}>
            <h5>user</h5>
            <p className={style.textStyle}>Sarah Simeon</p>
          </div>

          <div className={style.textWrapper}>
            <h5>Updated Date</h5>
            <p className={style.textStyle}>12 march, 2025</p>
          </div>

          <div className={style.textWraperRowStyle}>
            <div style={{ marginTop: "1rem" }}>
              <div className={style.textWrapper}>
                <>
                  <h5>Organization</h5>
                  <p className={style.textStyle}>Language Institution</p>
                </>
                <>
                  <h5>Start Date</h5>
                  <p className={style.textStyle}>12 may 2021</p>
                </>
              </div>
            </div>

            <div className={style.textWrapper}>
              <div style={{ display: "block" }}>
                <>
                  <h5>Job Role</h5>
                  <p className={style.textStyle}>Language instructor</p>
                </>
                <>
                  <h5>End Date</h5>
                  <p className={style.textStyle}>4 Augus 2024</p>
                </>
              </div>
            </div>
          </div>
          <hr
            style={{
              marginTop: "1rem",
              marginBottom: "2rem",
              fontWeight: "lighter",
            }}
          />
          <div className="dashboard-button">
            <Button name="Approve" type="activate-button" />
            <Button name="Reject" type="delete-button" />
          </div>
        </div>
      </>
    </Dashboard>
  );
}
